export const EVENT_NAME_FORM_BTN: string = 'cod_b2b_click_form_button'
